<!-- Footer -->

<template>
  <footer class="container-fluid border-top">
    <nav>
      <ul class="nav justify-content-center small">
        <li class="nav-item">
          <a v-bind:href="privacyLink"
            target="_blank"
            class="nav-link p-2"
            tabindex="2">
            Privacy
          </a>
        </li>

        <li class="nav-item">
          <span class="text-muted p-2 d-block">
            &copy;Enervee
          </span>
        </li>
      </ul>
    </nav>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapGetters('cmsText', [
      'getCMSText',
    ]),
    privacyLink() {
      return this.getCMSText('footer:privacy_link');
    },
  },
};
</script>
